import { createFileRoute } from '@tanstack/react-router';

import { AssessmentDetailPage } from '@/features/admin/components/assessment-detail-page';

export const Route = createFileRoute('/admin/assessments/$id')({
  component: AssessmentDetailPage,
});
